/**
 * Links to the files of a CMS page are stored without a host: `/api/cmsFile/{id}`. Every application serves that
 * path from its own API, so each one puts its API address in front of the link when it shows the content. Here that
 * address is the environment's `REACT_APP_BASE_URL`; it is never assumed to share a host or a port with the front end.
 */
const STORED_LINK = /(\b(?:src|href)\s*=\s*["'])\/api\/cmsFile\//gi;

/** The API address without trailing slashes, so `https://host/api` and `https://host/api/` behave the same. */
const apiRoot = (apiUrl: string): string => apiUrl.replace(/\/+$/, '');

/**
 * The content with every stored file link in `src` and `href` pointing at the API; any other link is untouched.
 * Without an API address there is nothing to point at, so the content is returned as it is.
 */
export const resolveCmsFileLinks = <T extends string | null | undefined>(
    html: T,
    apiUrl: string | undefined = process.env.REACT_APP_BASE_URL
): T => {
    if (!html || !apiUrl) {
        return html;
    }

    const root = apiRoot(apiUrl);
    return html.replace(STORED_LINK, (_match, attribute: string) => `${attribute}${root}/cmsFile/`) as T;
};
